import { object, string } from 'yup';

export enum OneTimeCodeFieldNames {
  Code = 'code',
}

export type TOneTimeCodeVerificationFields = {
  [OneTimeCodeFieldNames.Code]: string;
};

export const oneTimeCodeVerificationValidationSchema = object().shape({
  [OneTimeCodeFieldNames.Code]: string()
    .label('Code')
    .default('')
    .nullable()
    .trim()
    .length(6)
    .matches(/^\d{6}/i, {
      message: 'Code should contain only digits',
      excludeEmptyString: true,
    })
    .required(),
});
